import OrderList from "./ListPage/OrderList";
import MaterialList from "./ListPage/MaterialList";
import UploadTracking from "./UploadPreview/UploadTracking";
import UploadOrder from "./UploadPreview/UploadOrder";
import UserInfo from "./UserInfo/UserInfo";
import ChangePasswordPage from "./UserInfo/ChangePasswordPage";
import UserList from "./UserList/UserList";
import CreateUser from "./CreateForm/CreateUser";
import CreateMaterial from "./CreateForm/CreateMaterial";
import CreateOrder from "./CreateForm/CreateOrder";
import MaterialAttributeConfig from "./ListPage/MaterialAttributeConfig";
import MaterialAttributesPage from "./ListPage/MaterialAttributes";
import ApiKeys from "./ApiKeys/ApiKeys";
import ProductAlbumList from "./ListPage/ProductAlbumList";
import ProductAlbumExportFormatManager from "./ListPage/ProductAlbumExportFormatManager";

export const dashboardPath = (
  admin: boolean = false,
  ba: boolean = false,
  warehouse: boolean = false,
  customer: boolean = true,
  finance: boolean = false,
  purchaser: boolean = false,
  sales: boolean = false,
) => [
  {
    name: "订单",
    subPaths: [
      {
        path: "orders",
        name: "订单列表",
        element: <OrderList />,
        auths: !purchaser,
        index: true,
      },
      {
        path: "upload-order",
        name: "订单上传",
        element: <UploadOrder />,
        auths: admin || ba || customer || sales,
      },
      {
        path: "create-order",
        name: "创建订单",
        element: <CreateOrder />,
        auths: admin || ba || customer || sales,
      },
      {
        path: "upload-tracking",
        name: "物流上传",
        element: <UploadTracking />,
        auths: admin || warehouse,
      },
    ],
  },
  {
    name: "物料",
    subPaths: [
      {
        path: "materials",
        name: "物料列表",
        element: <MaterialList />,
        auths: !customer,
      },
      {
        path: "create-material",
        name: "添加物料",
        element: <CreateMaterial />,
        auths: admin || ba || purchaser,
      },
      {
        path: "product-album",
        name: "产品图册",
        element: <ProductAlbumList />,
        auths: admin || ba || warehouse || finance || sales,
      },
      {
        path: "product-album-formats",
        name: "图册导出格式",
        element: <ProductAlbumExportFormatManager />,
        auths: admin || ba || warehouse || finance || sales,
      },
    ],
  },
  {
    name: "价格",
    subPaths: [
      {
        path: "material-price",
        name: "价格列表",
        element: <MaterialAttributesPage />,
        auths: admin || ba || finance || purchaser || sales,
      },
      {
        path: "material-attribute",
        name: "价目列编辑",
        element: <MaterialAttributeConfig />,
        auths: admin,
      },
    ],
  },
  {
    name: "用户管理",
    subPaths: [
      {
        path: "user-info",
        name: "个人信息",
        element: <UserInfo />,
        auths: true,
      },
      {
        path: "password",
        name: "修改密码",
        element: <ChangePasswordPage />,
        auths: true,
      },
      {
        path: "api-keys",
        name: "API Key",
        element: <ApiKeys />,
        auths: true,
      },
      {
        path: "add-user",
        name: "添加用户",
        element: <CreateUser />,
        auths: admin || ba,
      },
      {
        path: "customers",
        name: "客户列表",
        element: <UserList type="customer" />,
        auths: admin || finance,
      },
      {
        path: "sales",
        name: "员工列表",
        element: <UserList type="staff" />,
        auths: admin,
      },
    ],
  },
];
